module.exports = require("ieee754");


//////////////////
// WEBPACK FOOTER
// external "ieee754"
// module id = 582
// module chunks = 0